<template>
  <div class="withdrawal" :class="isScroll ? '' : 'isBackground'">
    <Header :title="title" :right-content="rightContent" />
    <div id="content">
      <div class="select-account-container">
        <SelectAccount @onConfirmAccount="onConfirmAccount" />
      </div>
      <div v-if="useUSDT && useBank" class="bankList">
        <div class="itemTit">
          <span>取款方式</span>
          <div class="flex-center">
            <button
              v-if="useUSDT"
              style="margin-right: 10px"
              class="button"
              :class="{ active: withdrawMethod === 'USDT' }"
              @click="switchWithdrawMethod('USDT')"
            >
              电子钱包
            </button>
            <button
              class="button"
              :class="{ active: withdrawMethod === 'BANK' }"
              @click="switchWithdrawMethod('BANK')"
            >
              银行卡
            </button>
          </div>
        </div>
      </div>
      <div class="layout">
        <div v-if="withdrawMethod === 'BANK' && useBank" class="bankList">
          <div class="itemTit">
            <span>取款至</span><span
              @click="goAddBankCard"
            >添加新银行卡<img
              src="@/assets/images/template/a_top_return_r.png"
            ></span>
          </div>
          <div class="itemList">
            <div>
              <SelectBank :curr-bank="selectedBank" :bank-list="withdrawList" @onConfirmBank="onConfirmBank" />
            </div>
          </div>
        </div>
        <div v-if="useUSDT && withdrawMethod === 'USDT'" class="bankList">
          <div class="itemTit add-wallet-wrapper">
            <span>取款至</span>
            <div v-if="walletList.length === 0" class="add-wallet-container">
              <div class="add-wallet" @click="toggleAddWallet">
                <span>添加钱包+</span>
              </div>
              <!-- <span class="add-wallet-text">尚未注册钱包，<span class="red" @click="registerWallet">一键注册</span></span> -->
            </div>
            <div v-if="walletList.length > 0" class="select-wallet-container">
              <div
                v-for="(wallet, index) in walletList"
                :key="'wallet-options-' + index"
                class="wallet-selection"
                :class="{ 'is-active': selectedWalletIdx === index }"
                @click="switchWallet(index)"
              >
                <span
                  style="
                    text-align: center;
                    display: flex;
                    justify-content: center;
                  "
                >
                  {{ wallet.protocol }}
                  {{
                    wallet.walletAddress.replace(
                      /(\w{4})\w+(\w{4})/,
                      '$1 **** $2'
                    )
                  }}
                </span>
              </div>
              <div v-if="walletList.length < maxWallets" class="wallet-selection">
                <span
                  style="
                    text-align: center;
                    display: flex;
                    justify-content: center;
                  "
                  @click="toggleAddWallet"
                >添加钱包+</span>
              </div>
            </div>
          </div>
        </div>
        <div
          v-if="
            (withdrawMethod === 'USDT' && walletAddress !== '') ||
              (withdrawMethod === 'BANK' && withdrawList.length > 0)
          "
          class="amount"
        >
          <div
            class="w_title"
            :style="{ marginTop: withdrawMethod === 'USDT' ? '20px' : '0' }"
          >
            <span>取款金额（{{ withdrawMethod === 'BANK' ? '人民币' : '美元' }}）</span>
          </div>
          <div v-if="withdrawMethod == 'BANK'" class="amountList">
            <ul>
              <li
                v-for="(amountOption, index) in filteredAmountOptionList"
                :key="`amount-option-cny-${index}`"
                :class="{ checked: selectedAmountOptionIndex == index }"
                @click="selectAmountOption(amountOption, index)"
              >
                <span>{{ amountOption == Math.max(...amountOptionList) ? `>${amountOption}` : amountOption }}</span>
              </li>
            </ul>
          </div>
          <div
            v-if="!(withdrawMethod == 'BANK' && selectedAmountOptionIndex != filteredAmountOptionList.length - 1)"
            class="inputAmount"
          >
            <span>{{ withdrawMethod === 'BANK' ? '¥' : '$' }}</span>
            <input
              v-model="amount"
              type="number"
              min="0"
              :placeholder="`最多可取${withdrawMethod === 'BANK' ? `${advisableCreditAmountInCNY}人民币` : `${advisableCreditAmount}美元` }`"
              @keyup="onKeyUp"
            >
            <p @click="allWithdraw">全部提现</p>
          </div>
          <div v-if="withdrawMethod == 'BANK' && selectedAmountOptionIndex == filteredAmountOptionList.length - 1" class="warning" style="padding: 0">
            为保障安全快速到账，建议提现个位数和十位数不为零的金额
          </div>
          <div v-if="amount != ''" class="w_title">
            <p v-if="withdrawMethod === 'BANK'">
              温馨提示：今日美元汇率为{{ rate }}，包括手续费后，预计扣除账号额度美元<em>{{ amountPlusFeeInUSD }}</em>
            </p>
            <p v-else>
              温馨提示：今日美元汇率为{{ rate }}，扣除手续费后，预计到账{{
                getDisplayCurrencyText(targetCurrency)
              }}<em>{{ ratedAmountWithFee }}</em>，实际到账金额可能与此不一致。

            </p>
          </div>
        </div>
        <section class="fees-section" :class="{ 'fee-loading': gettingFees }">
          <div
            v-if="
              (withdrawMethod === 'USDT' && walletAddress !== '') ||
                (withdrawMethod === 'BANK' && withdrawList.length > 0)
            "
            class="fee"
          >
            <span
              @click="withdrawalNoticePop"
            >手续费<img
              src="@/assets/images/template/remind.png"
            ></span>
            <span v-if="withdrawMethod === 'BANK'">¥{{ amount == '' ? '0.00' : feeInCNY }}</span>
            <span v-else>{{ amount == '' ? '0.00' : fee }}</span>
          </div>
          <div class="instructions" @click="withdrawalInstructionsPop">大额取款须知 <img
            src="@/assets/images/template/remind.png"
          ></div>
          <div
            v-if="withdrawMethod === 'BANK' && withdrawList.length > 0"
            class="submit"
            :class="amount != '' && amount > 0 && !isInvalidBankAndProv() && !isInvalidBankInputAmount() ? 'suc' : ''"
            @click="submit"
          >
            <p>提现</p>
          </div>
          <div
            v-else-if="walletAddress !== ''"
            class="submit"
            :class="
              protocol !== 'BEP20' && amount != '' && amount > 0 && walletAddress !== '' ? 'suc' : ''
            "
            @click="submit"
          >
            <p>提现 {{ getDisplayCurrencyText(targetCurrency) }}</p>
          </div>
          <div class="errMessage">
            <p>{{ errMessage }}</p>
          </div>

          <div v-if="withdrawMethod == 'BANK'" class="warning" style="color: #000">
            溫馨提示：请不要使用工商银行(广东省)操作取款, 以便资金快速到账, 您可绑定其他名下银行卡取款。
          </div>
          <div v-else class="warning">
            温馨提示：请使用ERC20或TRC20链类型钱包进行取款，以便资金快速到账。
          </div>

          <div v-if="withdrawMethod == 'USDT'" class="warning">
            节假日USDT出金可能会延迟至当日17:00统一汇出, 敬请留意。
          </div>
        </section>
      </div>
    </div>
    <chat />
    <!--取款手续费须知-->
    <div v-if="isWithdrawalNoticePop" class="popFixed">
      <div class="masking" @click="withdrawalNoticePop" />
      <div class="tcCon">
        <div class="item">
          <span>取款手续费须知</span>
          <div class="explain">
            <!-- <p class="txtLeft">
              1、单笔取款50美元以下，公司将在汇款时扣取取款金额中的3美元作为取款手续费。
            </p> -->
            <p class="txtLeft">
              1、如客户注资后交易量不足注资金额的60%，及最后一次注资金额并未用于投资交易，将扣取提款金额的6%作为取款手续费。
            </p>
            <p class="txtLeft">
              2、完成交易量后, 24小时内最多可免费取款2次, 如24小时内取款第3次, 则每次取款需扣取取款金额的4%作为手续费用。
            </p>
            <div v-if="useUSDT && withdrawMethod === 'USDT'">
              <p class="txtLeft">
                3、  当取款低于50美元，需收取3美元手续费用。
              </p>
            </div>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="withdrawalNoticePop">知道了</span>
        </div>
      </div>
    </div>
    <!--大额取款须知-->
    <div v-if="isWithdrawalInstructionsPop" class="popFixed">
      <div class="masking" @click="withdrawalInstructionsPop" />
      <div class="tcCon">
        <div class="item">
          <span>大额取款须知</span>
          <div class="explain">
            <!-- <p class="txtLeft">
              1、单笔取款50美元以下，公司将在汇款时扣取取款金额中的3美元作为取款手续费。
            </p> -->
            <p class="txtLeft">
              1. 公司会对于24小时内等于或大于2万美元的大额取款进行核实，相关部门不定期也会随机抽查审批核实。
            </p>
            <p class="txtLeft">
              2. 以上情况，一般工作日9:00-18:00申请的取款当天可以审批完成，其他时间段的申请会延至下一个工作时间段处理。有疑问请及时联系客服咨询。
            </p>
          </div>
        </div>
        <div class="btnCon only">
          <span @click="withdrawalInstructionsPop">知道了</span>
        </div>
      </div>
    </div>
    <!--存取款流程-->
    <DepositAndWithdrawal
      v-if="isDepositAndWithdrawal"
      :key="depositAndWithdrawalKey"
      :source="source"
      :this-page-type="pageType"
      :money-status="moneyStatus"
      @getFaceVal="getFaceVal"
    />
    <!--点击确认再次验证人脸-->
    <ButtonCertify
      v-if="isButtonCertify"
      :source="source"
      :button-data="buttonData"
      :money-status="moneyStatus"
    />
    <NewCanWithdrawalModule
      :show-alert-pop="showAlertPop"
      :can-withdraw="canWithdraw"
      @alertOnClose="alertOnClose"
    />
    <!-- 工商銀行 + 廣東省提示 -->
    <div
      v-if="showBankProvWarningPop"
      class="popFixed"
    >
      <div
        class="masking"
        @click="closeBankProvWarningPop"
      />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">请使用其他银行银行卡或电子钱包取款， 以便资金快速到账。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeBankProvWarningPop">我知道了</span>
        </div>
      </div>
    </div>
    <!-- BEP20 提示 -->
    <div
      v-if="showBEP20WarningPop"
      class="popFixed"
    >
      <div
        class="masking"
        @click="closeBEP20WarningPop"
      />
      <div class="tcCon">
        <div class="item">
          <span>温馨提示</span>
          <p class="txtLeft">BEP20链钱包取款暂停，请使用或添加其他链类型钱包。</p>
        </div>
        <div class="btnCon only">
          <span @click="closeBEP20WarningPop">我知道了</span>
        </div>
      </div>
    </div>
    <CampaignAlertPopup />
  </div>
</template>

<script>
require('@/assets/css/withdrawal.css')
import Header from '@/view/module/Header.vue'
import Chat from '@/view/module/Chat.vue'
import api from '@/plugins/api'
import DepositAndWithdrawal from '@/view/module/DepositAndWithdrawal.vue'
import ButtonCertify from '@/view/module/ButtonCertify.vue'
import { mapState } from 'vuex'
import { getDisplayCurrencyText } from '@/utils/helper.js'
import NewCanWithdrawalModule from '@/view/module/NewCanWithdrawalModule'
import { MAX_WALLETS } from '@/utils/constants'
import SelectAccount from '@/view/module/SelectAccount.vue'
import SelectBank from '@/view/module/SelectBank.vue'
import CampaignAlertPopup from '@/view/module/CampaignAlertPopup.vue'

export default {
  name: 'Withdrawal',
  components: {
    Header,
    Chat,
    DepositAndWithdrawal,
    ButtonCertify,
    NewCanWithdrawalModule,
    SelectAccount,
    SelectBank,
    CampaignAlertPopup
  },
  data() {
    const _this = this
    const u = navigator.userAgent
    return {
      title: '取款',
      rightContent: 'withdrawal',
      isWithdrawalNoticePop: false,
      isWithdrawalInstructionsPop: false,
      isDepositAndWithdrawal: true,
      moneyStatus: 'withdrawal',
      bankLogoList: process.env.VUE_APP_BANKLOGO,
      amount: '',
      withdrawList: [],
      rate: '', // 汇率
      bankCode: '', // 银行code
      bankNum: '', // 银行账号
      bankName: '', // 银行名称
      bankProvince: '',
      fee: '', // 手续费
      advisableCreditAmount: '', // 可取金额
      errMessage: '',
      identityStatus: false, // 证件照片
      bankProofStatus: false, // 银行卡证明
      addressStatus: false, // 地址证明
      credentialsStatus: false, // 手持证件照
      isWithdrawal: '',
      source: 'withdrawal',
      isScroll: '',
      buttonData: '',
      isButtonCertify: false,
      targetCurrency: 'CNY',
      chainType: 'ERC20', // 链类型
      isAndroid: u.indexOf('Android') > -1 || u.indexOf('Linux') > -1,
      isIOS: !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/),
      isFaceValidate: true, // 是否需要人脸识别
      appObj: '',
      withdrawMethod: 'BANK',
      addingWallet: false,
      useUSDT: false,
      useBank: false,
      walletList: [],
      walletCompany: '',
      walletAddress: '',
      selectedWalletIdx: 0,
      canWithdraw: {
        bank: false,
        usdt: false
      },
      showAlertPop: false,
      getDisplayCurrencyText,
      gettingFees: false,
      minAmount: {
        bank: null, // CNY
        usdt: null // USD
      },
      maxAmount: {
        bank: null,
        usdt: null
      },
      showBankProvWarningPop: false,
      showBEP20WarningPop: false,
      amountOptionList: process.env.VUE_APP_WITHDRAWAL_AMOUNT_OPTION_LIST.split(','),
      selectedAmountOptionIndex: -1,
      selectedBank: null,
      depositAndWithdrawalKey: 0
    }
  },
  computed: {
    ...mapState([
      'user',
      'gts2AccountId',
      'platform',
      'currency',
      'withdrawalData',
      'gts2CustomerId',
      'pageType',
      'sourceType'
    ]),
    ratedAmount: function() {
      return this.amount && this.amount !== ''
        ? Math.ceil(this.amount * this.rate)
        : '--'
    },
    ratedAmountWithFee: function() {
      return this.amount && this.amount !== ''
        ? this.withdrawMethod == 'BANK'
          ? Math.floor(Number(this.amount) - Math.ceil(Number(this.fee) * Number(this.rate)))
          : parseFloat((Number(this.amount) - Number(this.fee)) * this.rate).toFixed(2)
        : '--'
    },
    amountWithFee: function() {
      return this.amount && this.amount !== ''
        ? Math.ceil(Number(this.amount) - Number(this.fee))
        : '--'
    },
    advisableCreditAmountInCNY: function() {
      return this.advisableCreditAmount !== '' ? Math.floor(this.advisableCreditAmount * this.rate) : '--'
    },
    amountPlusFeeInUSD: function() {
      return this.amount !== '' && this.rate !== '' && this.fee !== '--' ? Math.round((Number(this.amount) / this.rate + Number(this.fee)) * 100) / 100 : '--'
    },
    feeInCNY: function() {
      return this.fee !== '' && this.fee !== '' ? Math.round(Number(this.fee) * this.rate) : '--'
    },
    filteredAmountOptionList: function() {
      return this.amountOptionList
    }
  },
  watch: {
    amount: {
      deep: true,
      handler(newValue, oldValue) {
        if (newValue && newValue != '') {
          if (isNaN(newValue) || String(newValue).indexOf('-') >= 0) {
            this.amount = newValue.replace('-', '')
          }
          if (newValue.toString().split('.')[1]) {
            const fixed = newValue.toString().split('.')[1].length
            if (fixed > 2) {
              newValue
                .toString()
                .split('.')[1]
                .slice(0, 2)
              newValue =
                newValue.toString().split('.')[0] +
                '.' +
                newValue
                  .toString()
                  .split('.')[1]
                  .slice(0, 2)
              this.amount = newValue
            }
          }

          if (this.withdrawMethod === 'BANK') {
            if (parseFloat(newValue) > parseFloat(this.advisableCreditAmountInCNY)) {
              // this.amount = this.advisableCreditAmountInCNY
            }
          } else {
            if (parseFloat(newValue) > parseFloat(this.advisableCreditAmount)) {
              this.amount = this.advisableCreditAmount
            }
          }
          this.gettingFees = true
          this.delayTimer(() => {
            this.errMessage = ''
            this.feeData()
          })
          // setTimeout(() => {
          //   this.feeData()
          // }, 500)
          this.hasScrollbar()
        }
      }
    }
  },
  mounted() {
    this.initMounted()
  },
  activated() {
    this.removeFixed()
    this.$bus.$emit('loading', true)
    window.scrollTo(0, 0)
    this.hasScrollbar()
  },
  methods: {
    initMounted() {
      if (this.withdrawalData) this.$store.dispatch('setWithdrawalData', {})

      this.removeFixed()
      this.$bus.$emit('loading', true)
      window.scrollTo(0, 0)
      this.hasScrollbar()
      this.advisableCredit(0)
      this.getMinAmount()
      this.getWithdrawMethod()
      if (this.pageType == 'app' || this.sourceType == 'old') {
        this.checkFaceValidate()
      }

      this.maxWallets = MAX_WALLETS
      // Reset isButtonCertify = false so that <ButtonCertify> component can re-render
      // after api.withdrawDataValidate when isButtonCertify = true
      this.isButtonCertify = false
    },
    forceRerenderChildComponents() {
      this.depositAndWithdrawalKey++
    },
    removeFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.remove('mainFixed')
    },
    toggleFixed() {
      const mainH = document.getElementById('main')
      mainH.classList.toggle('mainFixed')
    },
    hasScrollbar() {
      if (
        document.body.scrollHeight >
        (window.innerHeight || document.documentElement.clientHeight)
      ) {
        this.isScroll = true
      } else this.isScroll = false
      return this.isScroll
    },
    goAddBankCard() {
      this.$bus.$emit('loading', false)
      if (this.withdrawList.length == 3) {
        this.$store.dispatch('setTabIndex', 0)
        this.$router.push({ path: '/home/bankList' })
      } else {
        this.$router.push({
          path: '/home/addBankCard',
          query: { bankType: 0 }
        })
      }
    },
    withdrawalNoticePop() {
      this.toggleFixed()
      this.isWithdrawalNoticePop = !this.isWithdrawalNoticePop
    },
    withdrawalInstructionsPop() {
      this.toggleFixed()
      this.isWithdrawalInstructionsPop = !this.isWithdrawalInstructionsPop
    },
    exchangeRate() {
      const data = {
        type: 2,
        sourceCurrency: this.currency,
        targetCurrency: this.targetCurrency
      }
      api.getRate(data).then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            this.rate = res.data.data
          }
        }
      })
    },
    withdrawBankList() {
      const arrList = []
      api.getWithdrawBankList().then((res) => {
        this.$bus.$emit('loading', true)
        if (res.status) {
          if (res.data.code == 200) {
            this.switchWithdrawMethod('BANK')
            if (res.data.data.withdrawBankList) {
              const list = res.data.data.withdrawBankList
              for (const j in list) {
                if (list[j].approveStatus == 'APPROVAL') {
                  arrList.push(list[j])
                }
              }
              this.withdrawList = arrList
              this.selectedBank = arrList[0]

              this.isInvalidBankAndProv(() => (this.showBankProvWarningPop = true))
            }
          }
        }
      })
    },
    allWithdraw() {
      this.advisableCredit(1)
    },
    advisableCredit(type) {
    // 0：自动  1：点击
      api.getAdvisableCredit(this.gts2AccountId).then((res) => {
        if (res.status) {
          if (res.data.code == 200) {
            if (type == 1) {
              this.amount = res.data.data.advisableCredit

              if (this.withdrawMethod === 'BANK') {
                this.amount = Math.floor(this.amount * this.rate)
              }
            }
            this.advisableCreditAmount = res.data.data.advisableCredit
          }
        }
      })
    },
    feeData(type) {
      if (type === 1) {
        this.$bus.$emit('loading', false)
      }
      const data = {
        gts2AccountId: this.gts2AccountId,
        accountNo: this.user.loginname,
        withdrewBankName: this.withdrawMethod === 'BANK' && this.selectedBank ? this.selectedBank.bank : '',
        withdrewBankAccount: this.withdrawMethod === 'BANK' && this.selectedBank ? this.selectedBank.bankAccountNumber : '',
        transAmount: this.withdrawMethod === 'BANK' ? parseFloat(this.amount / this.rate) : parseFloat(this.amount)
      }
      api.getWithdrawFeeList(data).then((res) => {
        this.gettingFees = false
        if (res.status) {
          if (res.data.code == 200) {
            this.fee = res.data.data.totalFee
            if (type == 1) {
              const data = {
                gts2AccountId: this.gts2AccountId,
                accountNo: this.user.loginname,
                transAmount: this.withdrawMethod === 'BANK' ? parseFloat(this.amount / this.rate) : parseFloat(this.amount),
                advisableCredit: this.advisableCreditAmount,
                platform: this.platform,
                // withdrewBankName: this.bankCode,
                // withdrewBankAccount: this.bankNum,
                isFaceValidate: this.isFaceValidate
              }
              this.withdrawValidate(data)
            }
          }
        }
      })
    },
    getFaceVal(data) {
      this.isFaceValidate = data
    },
    checkFaceValidate() {
      if (this.sourceType == 'old') {
        this.isFaceValidate = false
      } else this.isFaceValidate = true
    },
    async withdrawValidate(data) {
      const isValid = await this.isValidateMinAmount()
      if (isValid === null) return
      if (!isValid) {
        if (this.withdrawMethod === 'USDT') {
          this.errMessage = `扣除手续费后需达到${this.minAmount.usdt}美元以上`
        } else {
          this.errMessage = `扣除手续费后需达到${
            this.minAmount.bank
          }人民币以上`
        }
        this.$bus.$emit('loading', true)
        return
      }
      if (this.withdrawMethod === 'USDT') {
        data = {
          ...data,
          transCurrency: 'USDT',
          paymentType: 'VIRTUAL_CURRENCY',
          walletCompany: this.walletCompany,
          protocol: this.protocol,
          walletAddress: this.walletAddress,
          isUSDT: true,
          amount: Number(this.amount),
          fee: this.fee,
          rate: this.rate,
          chainType: this.chainType,
          isFaceValidate: this.isFaceValidate
        }
      } else {
        const amount = Number(this.amount) / this.rate
        data = {
          ...data,
          transCurrency: 'CNY',
          paymentType: 'REAL_CURRENCY',
          // withdrewBankName: this.bankCode,
          // withdrewBankNameInCh: this.bankName,
          // withdrewBankAccount: this.bankNum,
          withdrewBankName: this.selectedBank ? this.selectedBank.bank : '',
          withdrewBankNameInCh: this.selectedBank ? this.selectedBank.bankName : '',
          withdrewBankAccount: this.selectedBank ? this.selectedBank.bankAccountNumber : '',
          isUSDT: false,
          amount: amount,
          fee: Number(this.fee),
          rate: this.rate,
          isFaceValidate: this.isFaceValidate
        }
      }

      api.withdrawDataValidate(data).then((res) => {
        if (res.status) {
          if (res.data.code == 200 && res.data.code_desc == 'success') {
            this.$store.dispatch('setWithdrawalData', data)
            this.$router.push({ path: '/home/withdrawalConfirm' })
          } else if (res.data.code == 1011) {
            this.buttonData = res.data.data
            this.isButtonCertify = true
          } else {
            this.$bus.$emit('loading', true)
            this.errMessage = res.data.code_desc
          }
        }
      })
    },
    submit() {
      if (this.isInvalidBankAndProv()) {
        return
      }

      if (this.withdrawMethod === 'USDT') {
        if (
          this.protocol !== 'BEP20' &&
          this.amount !== '' &&
          this.amount > 0 &&
          this.walletAddress !== ''
        ) {
          this.getMaxAmount().then(() => {
            if (this.maxAmount.usdt > -1 && Number(this.ratedAmountWithFee) > this.maxAmount.usdt) {
              this.errMessage = `目前取款金额不可超过${this.maxAmount.usdt}${this.getDisplayCurrencyText(this.targetCurrency)}以上`
              return
            } else {
              this.errMessage = ''
            }

            this.feeData(1)
          })
        }
      // if (
      //   this.amount != "" &&
      //   this.amount >= 30 &&
      //   this.walletAddress !== ""
      // ) {
      //   this.feeData(1);
      // } else if (this.amount < 30) {
      //   this.errMessage = "USDT 最低取款金額為 30 USD";
      // }
      } else {
        if (this.amount != '' && this.amount > 0) {
          if (this.isInvalidBankInputAmount()) {
            return
          }

          this.getMaxAmount().then(() => {
            if (this.maxAmount.bank > -1 && Number(this.amount) > this.maxAmount.bank) {
              this.errMessage = `目前取款金额不可超过${this.maxAmount.bank}${this.getDisplayCurrencyText(this.targetCurrency)}以上`
              return
            } else {
              this.errMessage = ''
            }

            this.feeData(1)
          })
        }
      }
    },
    // submitA9 () {
    //   let data = {
    //     gts2AccountId: this.gts2AccountId,
    //     accountNo: this.user.loginname,
    //     platform: this.platform,
    //     transAmount: this.amount,
    //     advisableCredit: this.advisableCreditAmount,
    //     transCurrency: "USDT",
    //     chainType: this.chainType,
    //     usdtUrl: this.USDTAddress,
    //     isFaceValidate: this.isFaceValidate,
    //   };
    //   if (this.amount != '' && this.amount > 0 && this.USDTAddress != '') {
    //     this.$bus.$emit('loading', false);
    //     this.withdrawValidate(data)
    //   }
    // },
    // new
    switchWithdrawMethod(method) {
      if (!this.canWithdraw[method.toLowerCase()]) {
        this.showAlertPop = true
        return
      }
      this.selectedAmountOptionIndex = -1
      this.withdrawMethod = method
      this.amount = ''
      this.errMessage = ''
      if (method === 'USDT' && this.walletList.length > 0) {
        this.switchWallet(0)
      } else if (method === 'BANK') {
        this.targetCurrency = 'CNY'
        this.exchangeRate()
        this.isInvalidBankAndProv(() => (this.showBankProvWarningPop = true))
      }
    },
    getWithdrawMethod() {
      this.$bus.$emit('loading', false)
      api.getWithdrawMethod().then((res) => {
        if (res.data.code === 200) {
          this.useUSDT = res.data.data.fictitious
          this.useBank = res.data.data.legal
          Promise.all([
            api.getCanWithdraw('REAL_CURRENCY'),
            api.getCanWithdraw('VIRTUAL_CURRENCY')
          ]).then(([canBank, canUsdt]) => {
            this.canWithdraw.bank = canBank.data.data.result
            this.canWithdraw.usdt = canUsdt.data.data.result
            if (this.useBank) {
              if (!this.canWithdraw.bank) {
                this.showAlertPop = true
              } else {
                this.withdrawBankList()
              }
            }
            if (this.useUSDT) {
              if (!this.canWithdraw.usdt) {
                this.showAlertPop = true
              } else {
                this.getWalletList()
              }
            }
            if (!this.useUSDT && !this.useBank) {
              this.showAlertPop = true
            }
          }).catch(() => {
            this.withdrawBankList()
            this.getWalletList()
          })
        }
      })
    },
    getWalletList() {
      api.getWalletList().then((res) => {
        this.$bus.$emit('loading', true)
        if (res.data.code === 200) {
          this.walletList = res.data.data
          if (!this.canWithdraw.bank || !this.useBank) {
            this.switchWithdrawMethod('USDT')
          }
        }
      })
    },
    toggleAddWallet() {
      this.$router.push({ path: '/home/RegisterUSDT', query: { fromWithdraw: 1 }})
    },
    switchWallet(index) {
      this.walletAddress = this.walletList[index].walletAddress
      this.walletCompany = this.walletList[index].walletCompany
      this.protocol = this.walletList[index].protocol
      if (this.protocol == 'BEP20') {
        this.showBEP20WarningPop = true
      }
      this.targetCurrency = this.walletList[index].walletCurrency
      this.selectedWalletIdx = index
      this.exchangeRate()
    },
    alertOnClose() {
      this.showAlertPop = false
    },
    getMinAmount() {
      try {
        return new Promise((resolve) => {
          api
            .getMinWithdraw()
            .then((res) => {
              if (res.status !== 200) {
                resolve(null)
                return
              }
              const { data } = res.data
              this.minAmount.bank = data.minWithdrawAmt
              this.minAmount.usdt = data.minWithdrawUsdtAmt
              resolve(this.minAmount)
            })
            .catch((error) => {
              resolve(null)
              console.error(error)
            })
        })
      } catch (error) {
        console.error(error)
      }
    },
    isValidateMinAmount() {
      return new Promise((resolve) => {
        if (this.withdrawMethod === 'USDT') {
          if (this.minAmount.usdt === null) {
            this.getMinAmount().then((res) => {
              if (res === null) {
                this.errMessage = '網路錯誤(000)'
                return resolve(null)
              }
            })
          } else {
            return resolve(Number(this.amountWithFee) >= this.minAmount.usdt)
          }
        } else {
          if (this.minAmount.bank === null) {
            this.getMinAmount().then((res) => {
              if (res === null) {
                this.errMessage = '網路錯誤(000)'
                return resolve(null)
              }
            })
          } else {
            return resolve(
              Number(this.amount) >= this.minAmount.bank
            )
          }
        }
      })
    },
    getMaxAmount() {
      try {
        return new Promise((resolve) => {
          api.getMaxWithdraw()
            .then((res) => {
              if (res.status !== 200) {
                resolve(false)
                return
              }
              const { data } = res.data
              this.maxAmount.usdt = data.maxWithdrawUsdtAmt
              this.maxAmount.bank = data.maxWithdrawAmt
              resolve(true)
            })
        })
      } catch (error) {
        console.error(error)
      }
    },
    delayTimer(callback, ms = 500) {
      clearTimeout(this.timer)
      this.timer = setTimeout(callback, ms)
    },
    closeBankProvWarningPop() {
      this.showBankProvWarningPop = false
    },
    closeBEP20WarningPop() {
      this.showBEP20WarningPop = false
    },
    isInvalidBankAndProv(callback) {
      if (this.withdrawMethod == 'BANK' && this.selectedBank && this.selectedBank.bank == 'ICBKCNBJXXX' && this.selectedBank.bankProvince == 'guangdong') {
        if (callback) callback()
        return true
      }

      return false
    },
    selectAmountOption(amountOption, index) {
      this.selectedAmountOptionIndex = index
      if (this.selectedAmountOptionIndex < this.amountOptionList.length - 1) {
        this.amount = amountOption
      } else {
        this.amount = ''
      }
    },
    isInvalidBankInputAmount() {
      return this.selectedAmountOptionIndex == this.amountOptionList.length - 1 && this.amount <= Math.max(...this.amountOptionList)
    },
    onKeyUp(event) {
      if (this.withdrawMethod == 'BANK') {
        event.target.value = event.target.value.replace(/\.\d+/, '')
      }
    },
    onConfirmAccount() {
      this.initMounted()
      this.forceRerenderChildComponents()
    },
    onConfirmBank(bank) {
      this.selectedBank = bank
      this.isInvalidBankAndProv(() => (this.showBankProvWarningPop = true))
      if (this.amount && this.amount != '') this.feeData()
    }
  }
}

</script>
